<template>
  <div class="data-analysis">
    <el-card shadow="never">
      <el-page-header
        @back="goBack"
        :content="'校区数据趋势图' + '(' + $route.query.school_name + ')'"
      >
      </el-page-header>

      <el-form
        ref="ruleForm"
        :inline="true"
        :model="form"
        class="form-style"
        size="mini"
      >
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="form.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions"
            @change="adminGetSysSchoolOperationInfoList"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <el-row style="margin-top: 20px">
        <el-col :span="24">
          <div>
            <div style="width: 100%; height: 300px" id="myChart11"></div>
          </div>
        </el-col>

        <el-col :span="24">
          <div>
            <div style="width: 100%; height: 300px" id="myChart13"></div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div style="width: 100%; height: 300px" id="myChart14"></div>
          </div>
        </el-col>

        <el-col :span="12">
          <div>
            <div style="width: 100%; height: 300px" id="myChart1-1"></div>
          </div>
        </el-col>

        <el-col :span="12">
          <div>
            <div style="width: 100%; height: 300px" id="myChart12"></div>
          </div>
        </el-col>

        <el-col :span="12">
          <div>
            <div style="width: 100%; height: 300px" id="myChart1-2"></div>
          </div>
        </el-col>

        <el-col :span="12">
          <div>
            <div style="width: 100%; height: 300px" id="myChart1-3"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <div style="width: 100%; height: 300px" id="myChart1-4"></div>
          </div>
        </el-col>

        <el-col :span="12">
          <div>
            <div style="width: 100%; height: 300px" id="myChart1-5"></div>
          </div>
        </el-col>

        <el-col :span="24">
          <div>
            <div style="width: 100%; height: 300px" id="myChart1-9"></div>
          </div>
        </el-col>

        <el-col :span="24">
          <div>
            <div style="width: 100%; height: 300px" id="myChart10"></div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { adminGetSysSchoolOperationInfoList } from '@/api/admin'
import moment from 'moment'

export default {
  name: 'school-history',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '半年',
            onClick(picker) {
              // const end = new Date();
              // const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              let month = moment(new Date())
                .subtract(6, 'months')
                .format('YYYY-MM-DD')
              let Nowmonth = moment().format('YYYY-MM-DD')

              console.log(month, 85565656)
              console.log(Nowmonth, 85565656)
              picker.$emit('pick', [
                month + ' 00:00:00',
                Nowmonth + ' 23:59:59',
              ])
            },
          },
        ],
      },
      value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      value2: '',

      //数据看板
      latestSysTotalInfo: {},

      //课程概况
      data_x_stu: [],
      data_y_stu: [],
      //数据看板
      myChart1_1: {}, //意向学员
      myChart1_2: {}, //试听学员
      myChart1_3: {}, //正式学员
      myChart1_4: {}, //试听班级
      myChart1_5: {}, //正式班级
      myChart1_6: {}, //试听讲次
      myChart1_7: {}, //常规讲次
      myChart1_8: {}, //体验校区
      myChart1_9: {}, //员工数
      myChart10: {}, //销售额
      myChart11: {}, //激活时长

      myChart12: {}, //沟通数

      StulistBySubject: [],

      data_x_school: [],
      data_y_school: [],
      SchoollistBySubject: [],

      form: {
        date: [],
      },
      page_no: 1,
      page_size: 365,
      total: 0,
      sysSchoolTchInfoList: [], //趋势图数据

      data_x: [],
      intended_stu_num: [],
      normal_class_num: [],
      normal_stu_num: [],
      normal_tch_plan_num: [],
      sales_num: [],
      stu_time_cost_num: [],
      try_class_num: [],
      try_school_num: [],
      try_stu_num: [],
      try_tch_plan_num: [],
      user_num: [],
      intended_stu_record_num: [], //沟通数
      jr_tch_work_comment_num: [],
      sc_tch_work_comment_num: [],
      py_tch_work_comment_num: [],
      stu_signed_tch_plan_num: [],
    }
  },
  computed: {},
  mounted() {
    if (this.$store.getters.adminToken) {
      this.init()
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: 'csm-grow',
      })
    },
    init() {
      let month = moment(new Date())
        .subtract(3, 'months')
        .format('YYYY-MM-DD')
      let Nowmonth = moment().format('YYYY-MM-DD')

      console.log(month, 85565656)
      console.log(Nowmonth, 85565656)
      this.form.date = [month + ' 00:00:00', Nowmonth + ' 23:59:59']
      console.log(this.form.date, 85565656)
      this.adminGetSysSchoolOperationInfoList()
    },

    //校区历史数据
    adminGetSysSchoolOperationInfoList() {
      adminGetSysSchoolOperationInfoList({
        schoolId: this.$route.query.school_id,
        start_date: this.form.date ? this.form.date[0] : '',
        end_date: this.form.date ? this.form.date[1] : '',
        page_no: 1,
        page_size: 365,
      }).then((res) => {
        console.log('校区历史数据')
        console.log(res)

        console.log('校区数据趋势图')
        console.log(res)

        this.sysSchoolTchInfoList = res.sysSchoolTchInfoList
        this.data_x = []
        this.intended_stu_num = []
        this.normal_class_num = []
        this.normal_stu_num = []
        this.normal_tch_plan_num = []
        this.sales_num = []
        this.stu_time_cost_num = []
        this.try_class_num = []
        this.try_school_num = []
        this.try_stu_num = []
        this.try_tch_plan_num = []
        this.user_num = []
        this.intended_stu_record_num = []
        this.jr_tch_work_comment_num = []
        this.sc_tch_work_comment_num = []
        this.py_tch_work_comment_num = []
        this.stu_signed_tch_plan_num = []

        for (let k = 0; k < this.sysSchoolTchInfoList.length; k++) {
          this.data_x.push(this.sysSchoolTchInfoList[k].created_time)
          //意向学员
          this.intended_stu_num.push(
            this.sysSchoolTchInfoList[k].intended_stu_num
          )
          //试听学员
          this.try_stu_num.push(this.sysSchoolTchInfoList[k].try_stu_num)
          //在读学员
          this.normal_stu_num.push(this.sysSchoolTchInfoList[k].normal_stu_num)
          //试听班级
          this.try_class_num.push(this.sysSchoolTchInfoList[k].try_class_num)
          //正式班级
          this.normal_class_num.push(
            this.sysSchoolTchInfoList[k].normal_class_num
          )
          //试听讲次
          this.try_tch_plan_num.push(
            this.sysSchoolTchInfoList[k].try_tch_plan_num
          )
          //常规讲次
          this.normal_tch_plan_num.push(
            this.sysSchoolTchInfoList[k].normal_tch_plan_num
          )

          //体验校区数
          this.try_school_num.push(this.sysSchoolTchInfoList[k].try_school_num)
          //员工数
          this.user_num.push(this.sysSchoolTchInfoList[k].user_num)
          //销售额
          this.sales_num.push(this.sysSchoolTchInfoList[k].sales_num)
          //已激活时长
          this.stu_time_cost_num.push(
            this.sysSchoolTchInfoList[k].stu_time_cost_num
          )
          //沟通数
          this.intended_stu_record_num.push(
            this.sysSchoolTchInfoList[k].intended_stu_record_num
          )
          //点评数
          this.jr_tch_work_comment_num.push(
            this.sysSchoolTchInfoList[k].jr_tch_work_comment_num
          )

          this.sc_tch_work_comment_num.push(
            this.sysSchoolTchInfoList[k].sc_tch_work_comment_num
          )

          this.py_tch_work_comment_num.push(
            this.sysSchoolTchInfoList[k].py_tch_work_comment_num
          )
          this.stu_signed_tch_plan_num.push(
            this.sysSchoolTchInfoList[k].stu_signed_tch_plan_num
          )
        }

        this.$nextTick(function() {
          this.drawLine1() //意向学员
          this.drawLine2() //试听学员
          this.drawLine3() //在读学员
          this.drawLine4() //试听班级数
          this.drawLine5() //正式班级
          //this.drawLine6(); //试听讲次
          //this.drawLine7(); //常规讲次
          //this.drawLine8(); //体验校区
          this.drawLine9() //员工数
          this.drawLine10() //销售额
          this.drawLine11() //已激活时长
          this.drawLine12() //沟通数
          this.drawLine13() //课后点评
          this.drawLine14() //学生课消
        })
      })
    },

    drawLine1() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_1 = this.$echarts.init(document.getElementById('myChart1-1'))
      // 绘制意向学员
      myChart1_1.setOption({
        title: { text: '意向学员' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '意向学员数',
            type: 'line',
            data: this.intended_stu_num,
          },
        ],
      })
    },

    drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_2 = this.$echarts.init(document.getElementById('myChart1-2'))
      // 绘制试听学员
      myChart1_2.setOption({
        title: { text: '试听学员' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '试听学员数',
            type: 'line',
            data: this.try_stu_num,
          },
        ],
      })
    },

    drawLine3() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_3 = this.$echarts.init(document.getElementById('myChart1-3'))
      // 绘制在读学员
      myChart1_3.setOption({
        title: { text: '在读学员' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '在读学员数',
            type: 'line',
            data: this.normal_stu_num,
          },
        ],
      })
    },

    drawLine4() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_4 = this.$echarts.init(document.getElementById('myChart1-4'))
      // 绘制试听班级
      myChart1_4.setOption({
        title: { text: '试听班级' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '试听班级数',
            type: 'line',
            data: this.try_class_num,
          },
        ],
      })
    },

    drawLine5() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_5 = this.$echarts.init(document.getElementById('myChart1-5'))
      // 绘制试听班级
      myChart1_5.setOption({
        title: { text: '正式班级' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '正式班级数',
            type: 'line',
            data: this.normal_class_num,
          },
        ],
      })
    },

    drawLine6() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_6 = this.$echarts.init(document.getElementById('myChart1-6'))
      // 绘制试听讲次
      myChart1_6.setOption({
        title: { text: '试听讲次' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '试听讲次数',
            type: 'line',
            data: this.try_tch_plan_num,
          },
        ],
      })
    },

    drawLine7() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_7 = this.$echarts.init(document.getElementById('myChart1-7'))
      // 绘制常规讲次
      myChart1_7.setOption({
        title: { text: '常规讲次' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '常规讲次数',
            type: 'line',
            data: this.normal_tch_plan_num,
          },
        ],
      })
    },

    drawLine8() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_8 = this.$echarts.init(document.getElementById('myChart1-8'))
      // 绘制体验校区
      myChart1_8.setOption({
        title: { text: '体验校区' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '体验校区',
            type: 'line',
            data: this.try_school_num,
          },
        ],
      })
    },

    drawLine9() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1_9 = this.$echarts.init(document.getElementById('myChart1-9'))
      // 绘制员工数
      myChart1_9.setOption({
        title: { text: '员工数' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '员工数',
            type: 'line',
            data: this.user_num,
          },
        ],
      })
    },

    drawLine10() {
      // 基于准备好的dom，初始化echarts实例
      let myChart10 = this.$echarts.init(document.getElementById('myChart10'))
      // 绘制员工数
      myChart10.setOption({
        title: { text: '销售额' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '销售额',
            type: 'line',
            data: this.sales_num,
          },
        ],
      })
    },

    drawLine11() {
      // 基于准备好的dom，初始化echarts实例
      let myChart11 = this.$echarts.init(document.getElementById('myChart11'))
      // 绘制员工数
      myChart11.setOption({
        title: { text: '激活时长' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '激活时长',
            type: 'line',
            data: this.stu_time_cost_num,
          },
        ],
      })
    },

    drawLine12() {
      // 基于准备好的dom，初始化echarts实例
      let myChart12 = this.$echarts.init(document.getElementById('myChart12'))
      // 绘制沟通数
      myChart12.setOption({
        title: { text: '跟进数' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '跟进数',
            type: 'line',
            data: this.intended_stu_record_num,
          },
        ],
      })
    },

    drawLine13() {
      // 基于准备好的dom，初始化echarts实例
      let myChart13 = this.$echarts.init(document.getElementById('myChart13'))
      // 绘制课后点评
      myChart13.setOption({
        title: { text: '课后点评' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: 'Jrcode',
            type: 'line',
            data: this.jr_tch_work_comment_num,
          },
          {
            name: 'Scratch',
            type: 'line',
            data: this.sc_tch_work_comment_num,
          },
          {
            name: 'Python',
            type: 'line',
            data: this.py_tch_work_comment_num,
          },
        ],
      })
    },
    drawLine14() {
      // 基于准备好的dom，初始化echarts实例
      let myChart14 = this.$echarts.init(document.getElementById('myChart14'))
      // 绘制课后点评
      myChart14.setOption({
        title: { text: '学生课消' },
        tooltip: {},
        xAxis: {
          data: this.data_x,
        },
        yAxis: {},
        series: [
          {
            name: '学生课消',
            type: 'line',
            data: this.stu_signed_tch_plan_num,
          },
        ],
      })
    },
    /* drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart2 = this.$echarts.init(document.getElementById("myChart2"));
      // 绘制图表
      this.myChart2.setOption({
        title: { text: "学员分布" },
        tooltip: {},
        xAxis: {
          data: this.data_x_stu,
        },
        yAxis: {},
        series: [
          {
            name: "学员数",
            type: "bar",
            data: this.data_y_stu,
          },
        ],
      });

      var that = this;

      this.myChart2.on("click", function (params) {
        console.log(params.name);
        that.$message.success(params.name);
      });
    },*/

    getStaff() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart3 = this.$echarts.init(document.getElementById('myChart3'))
      // 绘制图表
      this.myChart3.setOption({
        title: { text: '学校分布' },
        tooltip: {},
        xAxis: {
          data: this.data_x_school,
        },
        yAxis: {},
        series: [
          {
            name: '校区数',
            type: 'bar',
            data: this.data_y_school,
          },
        ],
      })

      var that = this

      this.myChart3.on('click', function(params) {
        console.log(params.name)
        that.$message.success(params.name)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.data-analysis {
  height: 100%;
  margin: 10px;

  .card_data {
    margin-bottom: 20px;
  }
}
</style>
